
import React, { Suspense } from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from "react-router-dom";
import './App.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './ScrollToTop';
import { BackToTop } from './components/back-to-top/BackToTop';
import Home from './views/frontend/home/Home';
import Signin from './views/frontend/signin/Signin';
import Signup from './views/frontend/signup/Signup';
import ForgotPassword from './views/frontend/forgot-password/ForgotPassword';
import ResetPassword from './views/frontend/reset-password/ResetPassword';
import Faq from './views/frontend/faq/Faq';
import About from './views/frontend/about/About';
import TermsConditions from './views/frontend/terms-condition/TermsConditions';
import PrivacyPolicy from './views/frontend/privacy-policy/PrivacyPolicy';
import HelpSupport from './views/frontend/help-support/HelpSupport';
import Contact from './views/frontend/contact/Contact';
import PublicItineraryDetails from './views/frontend/itinerary-details/PublicItineraryDetails';
import EmailVerifiedSuccessful from './views/frontend/email-verified-successful/EmailVerifiedSuccessful';
import CreateItinerary from './views/admin/manage-itinerary/CreateItinerary';
import Dashboard from './views/admin/dashboard/Dashboard';
import ChangePassword from './views/admin/change-password/ChangePassword';
import MyStays from './views/admin/my-stays/MyStays';
import ManageTravelers from './views/admin/manage-travelers/ManageTravelers';
import RequestQuote from './views/admin/manage-itinerary/RequestQuote';
import ItineraryPreview from './views/admin/manage-itinerary/ItineraryPreview';
import ItinerariesList from './views/admin/manage-itinerary/ItinerariesList';
import ItineraryDraftList from './views/admin/manage-itinerary/ItineraryDraftList';
import ManageProfile from './views/admin/manage-profile/ManageProfile';

import FrontendContainer from './containers/frontend-container/FrontendContainer';
import AdminContainer from './containers/admin-container/AdminContainer';
import { ProtectedRoute } from './components/auth-guard/ProtectedRoute';
import { UnprotectedRoute } from './components/auth-guard/UnprotectedRoute';
import PageNotFound from './components/page-not-found';
import MyActivities from './views/admin/my-activities/MyActivities';
import MyTransports from './views/admin/my-transports/MyTransports';

import MyTours from './views/admin/my-tours/MyTours';
import MyFoods from './views/admin/my-foods/MyFoods';
import MyOthers from './views/admin/my-others/MyOthers';
import Subscriptions from './views/frontend/subscriptions/Subscriptions';
import ManageSubscription from './views/admin/manage-subscription/ManageSubscription';
import { LoadingSpinnerOne } from './components/loading-spinner/Loader';
import AuthModal from './components/auth-modal';

const App = () => {

    return (
        <>
            <Suspense fallback={<LoadingSpinnerOne />}>
                <Router basename={`${process.env.REACT_APP_FILE_PATH}`}>
                    <ScrollToTop>
                        <Switch>
                            <Route exact path="/email-verified/" component={EmailVerifiedSuccessful} />
                            <Route exact path="/404" component={PageNotFound} />
                            <Route exact path='/:path?'>
                                <FrontendContainer>
                                    <Switch>
                                        <Route exact path="/" component={Home} />
                                        <Route exact path="/signin">
                                            <UnprotectedRoute>
                                                <Signin />
                                            </UnprotectedRoute>
                                        </Route>
                                        <Route exact path="/signup">
                                            <UnprotectedRoute>
                                                <Signup />
                                            </UnprotectedRoute>
                                        </Route>
                                        <Route exact path="/forgot-password">
                                            <UnprotectedRoute>
                                                <ForgotPassword />
                                            </UnprotectedRoute>
                                        </Route>
                                        <Route exact path="/reset-password">
                                            <ResetPassword />
                                        </Route>
                                        <Route exact path="/faq" component={Faq} />
                                        <Route exact path="/about" component={About} />
                                        <Route exact path="/terms-conditions" component={TermsConditions} />
                                        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
                                        <Route exact path="/help-support" component={HelpSupport} />
                                        <Route exact path="/contact" component={Contact} />
                                        <Route exact path="/details/" component={PublicItineraryDetails} />
                                        <Route exact path="/subscriptions" component={Subscriptions} />
                                        <Redirect to="/404" />
                                    </Switch>
                                </FrontendContainer>
                            </Route>
                            <Route path='/admin/:path?' exact>
                                <AdminContainer>
                                    <Switch>
                                        <Route exact path="/admin/dashboard">
                                            <ProtectedRoute>
                                                <Dashboard />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/create-itinerary">
                                            <ProtectedRoute>
                                                <CreateItinerary />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/change-password">
                                            <ProtectedRoute>
                                                <ChangePassword />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/itineraries-list">
                                            <ProtectedRoute>
                                                <ItinerariesList />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/transport">
                                            <ProtectedRoute>
                                                <MyTransports />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/stays">
                                            <ProtectedRoute>
                                                <MyStays />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/foods">
                                            <ProtectedRoute>
                                                <MyFoods />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/tours">
                                            <ProtectedRoute>
                                                <MyTours />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/others">
                                            <ProtectedRoute>
                                                <MyOthers />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/activities">
                                            <ProtectedRoute>
                                                <MyActivities />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/manage-travelers">
                                            <ProtectedRoute>
                                                <ManageTravelers />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/request-quote">
                                            <ProtectedRoute>
                                                <RequestQuote />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/itinerary-preview">
                                            <ProtectedRoute>
                                                <ItineraryPreview />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/manage-profile">
                                            <ProtectedRoute>
                                                <ManageProfile />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/itinerary-draft-list">
                                            <ProtectedRoute>
                                                <ItineraryDraftList />
                                            </ProtectedRoute>
                                        </Route>
                                        <Route exact path="/admin/manage-subscription">
                                            <ProtectedRoute>
                                                <ManageSubscription />
                                            </ProtectedRoute>
                                        </Route>
                                        <Redirect to="/404" />
                                    </Switch>
                                </AdminContainer>
                            </Route>
                        </Switch>
                    </ScrollToTop>
                    <AuthModal />
                </Router>
                <BackToTop />
                <ToastContainer position="top-right" hideProgressBar={true} theme="light" />
            </Suspense>
        </>
    );
}

export default App;

